import { getById } from 'services/content-service'
import useFetchData from './useFetchData'

const useGetContentById = (contentType, id) => useFetchData(() => getById(contentType, id), [contentType, id]).data

export default useGetContentById
